var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 42C33.046 42 42 33.046 42 22C42 10.954 33.046 2 22 2C10.954 2 2 10.954 2 22C2 33.046 10.954 42 22 42Z",
    stroke: "#699BF7",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28.986C6.632 30.041 8.527 30.041 9.684 28.986C11.42 27.402 9.922 22.598 12.354 21.273C14.784 19.948 18.489 25.821 21.951 23.889C25.413 21.956 21.625 16.802 24.027 14.713C26.43 12.623 29.554 14.98 30.1 11.486C30.646 7.99302 27.552 9.50802 26.958 6.20602C26.563 4.00602 26.563 2.84902 26.958 2.73602M27.02 41.35C25.147 39.432 24.472 37.65 24.997 36.002C25.784 33.53 27.083 33.676 27.649 32.148C28.215 30.62 26.616 28.443 30.164 26.583C32.53 25.343 35.783 26.779 39.923 30.894",
    stroke: "#699BF7",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.d299ef778d197081cd8afd2566783f42.svg";
export { ForwardRef as ReactComponent };